/**
 * Deep copy given object.
 * It supports
 *  - primitive types (number, string, array)
 *  - Uint8Array
 *  - objects
 *  - Date
 *
 * It may loose type for others...
 *
 * @param T Generic type of target/copied value.
 * @param target Target value to be copied.
 */
export const deepCopy = (target, hash = new WeakMap()) => {
    if (target === null) {
        return target;
    }
    if (target instanceof Date) {
        return new Date(target.getTime());
    }
    if (hash.has(target))
        return hash.get(target);
    if (target instanceof Array) {
        const cp = [];
        hash.set(target, cp);
        target.forEach((v) => {
            cp.push(v);
        });
        return cp.map((n) => deepCopy(n, hash));
    }
    if (target instanceof Uint8Array) {
        return new Uint8Array(target);
    }
    if (typeof target === 'object') {
        const cp = { ...target };
        hash.set(target, cp);
        Object.keys(cp).forEach((k) => {
            cp[k] = deepCopy(cp[k], hash);
        });
        return cp;
    }
    return target;
};
